import {EmojiFallback} from 'utils/emoji_fallback'

emoji = new EmojiFallback()

if document.body.getAttribute('id') == 'market-index'
  emoji.replaceInElement document.querySelector('#content .table-container')
